import React from 'react';

import { Container, Box, Typography } from '@material-ui/core';

import { Pathway as PathwayItem } from '../../../../components/Pathway';
import { Pathway } from '../../../../types';
import { secondsToHHHmmm } from '../../../../utils/helpers';
import useStyles from './styles';

interface PathwaysBlockProps {
  title: string;
  pathways: Pathway[];
}

const PathwaysBlock: React.FC<PathwaysBlockProps> = ({ title, pathways }) => {
  const classes = useStyles();

  return (
    <Box className={classes.wrapper}>
      <Container>
        <Typography variant="h2" className={classes.title}>
          {title}
        </Typography>
        <Box className={classes.pathwaysWrapper}>
          {pathways.map((item) => {
            const duration = secondsToHHHmmm(item?.duration);

            return (
              <div className={classes.pathwayItemWrapper} key={item?.id}>
                <PathwayItem
                  videoWidth={0}
                  name={item.name}
                  slug={item.slug}
                  imageUrl={item.image_url}
                  duration={duration}
                  countVideos={item.count_videos}
                  wrapperClass={classes.pathwayItem}
                />
              </div>
            );
          })}
        </Box>
      </Container>
    </Box>
  );
};

export default PathwaysBlock;
